import React from "react";
import { SearchCheckbox } from "./checkbox";
import { SearchLabels } from "./texts/labels";
import { PriceToggle } from "./toggle";
import { SearchSlider } from "./slider";
import { SearchSelect } from "./select";
import { FieldPath } from "react-hook-form";
import { SearchSliderSettings } from "./settings/slider";
import { SearchOptions } from "./options/options";

type SearchCommonFieldProps = {
    name: FieldPath<SearchFormInputs>;
    className?: string;
};

export const SearchCommonField = ({
    name,
    className
}: SearchCommonFieldProps) => {
    const parts = name.split(".");

    let firstPart = "",
        secondPart;
    if (parts.length > 1) {
        firstPart = parts[0];
        secondPart = parts[1];
    } else {
        secondPart = parts[0];
    }

    const label = SearchLabels[name] || `TODO ${secondPart.slice(0, 10)}`;

    if (
        [
            "beach",
            "beachSports",
            "city",
            "nature",
            "scenes",
            "landscapes"
        ].includes(firstPart)
    ) {
        return (
            <SearchCheckbox name={name} label={label} className={className} />
        );
    } else if (firstPart == "prices" && secondPart != "flightOrigin") {
        return <PriceToggle name={name} label={label} className={className} />;
    } else if (firstPart == "weather" && secondPart != "rainseason") {
        const settings = SearchSliderSettings[secondPart];
        return (
            <SearchSlider
                {...settings}
                name={name}
                label={label}
                className={className}
            />
        );
    } else if (
        ["month", "focus", "continent", "suitability"].includes(secondPart)
    ) {
        return <SearchSelect name={name} label={label} className={className} />;
    } else if (["flightOrigin", "visaOrigin"].includes(secondPart)) {
        return (
            <SearchSelect
                name={name}
                label={label}
                values={[...SearchOptions[name]]}
                className={className}
            />
        );
    } else if (["boat"].includes(secondPart)) {
        return (
            <SearchSelect
                name={name}
                label={label}
                values={[0, 1]}
                className={className}
            />
        );
    } else {
        return (
            <SearchSelect
                name={name}
                label={label}
                values={[0, 1, 2]}
                className={className}
            />
        );
    }
};
